export default __webpack_public_path__ + "static/media/safari.d8f6b7c3.png";